<div class="modal-body rewatch-dialog-box">
  <div class="text-center leave-class-box">
    <!-- <iframe width="560" height="500" [src]="data.recording.recording_files[0].play_url | safeurl"></iframe> -->
    <video width="560" height="315" sameSite="none" controls >
      <source [src]="data.recording.share_url | safeurl" type="video/mp4">
    </video>
  </div>
</div>